import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

const CONTROL_HEIGHT = '32px';
const CONTROL_RADIUS = '8px';
const CONTROL_BORDER = `1px solid ${theme.palette.neutral[200]}`;

export const rootSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
};

export const toolbarSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    [theme.breakpoints.down('md')]: {
        width: '100%',
        flexWrap: 'wrap',
    },
};

export const dateWrapperSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    height: CONTROL_HEIGHT,
    '& > div': {
        marginTop: 0,
        marginBottom: 0,
    },
    '& .MuiFormControl-root': {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
    },
    '& .MuiFormControl-marginNormal': {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
    },
    '& .MuiInputBase-root': {
        height: CONTROL_HEIGHT,
        minHeight: CONTROL_HEIGHT,
        background: theme.palette.common.white,
        borderRadius: CONTROL_RADIUS,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.neutral[200],
    },
    '& .MuiSelect-select': {
        py: 0,
        minHeight: CONTROL_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        fontSize: '13px',
    },
};

export const titleNoteSx: SxProps<Theme> = {
    fontSize: '12px',
    color: theme.palette.neutral[500],
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    cursor: 'help',
    '& svg': {
        fontSize: 14,
    },
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
};

export const sortToggleGroupSx: SxProps<Theme> = {
    height: CONTROL_HEIGHT,
    '& .MuiToggleButtonGroup-grouped': {
        borderRadius: CONTROL_RADIUS,
        textTransform: 'none',
        fontSize: '13px',
        fontWeight: 500,
        px: 1.5,
        height: CONTROL_HEIGHT,
        color: theme.palette.neutral[700],
        backgroundColor: theme.palette.common.white,
        border: CONTROL_BORDER,
        '&:not(:first-of-type)': {
            marginLeft: '-1px',
            borderLeftColor: theme.palette.neutral[200],
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.secondary,
            borderColor: theme.palette.primary.main,
            zIndex: 1,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
    },
};

export const iconBtnSx: SxProps<Theme> = {
    '&.MuiIconButton-root': {
        height: CONTROL_HEIGHT,
        width: CONTROL_HEIGHT,
        background: theme.palette.common.white,
        border: CONTROL_BORDER,
        borderRadius: CONTROL_RADIUS,
        color: theme.palette.neutral[500],
        '&:hover': {
            borderColor: theme.palette.neutral[300],
            background: theme.palette.common.white,
        },
        '& svg': {
            fontSize: '20px',
        },
    },
};


export const stackSx: SxProps<Theme> = {
    p: 1,
    gap: 0.5,
    // Below a desktop the list stops being its own scrolling box and the page scrolls instead: a
    // scroller inside a scroller is the thing that makes a phone feel like it is fighting back, and
    // `vh` counted the address bar, so the bottom of the box was under the bottom of the screen.
    minHeight: {xs: 'unset', md: 'calc(100dvh - 300px)'},
    maxHeight: {xs: 'none', md: 'calc(100dvh - 300px)'},
    overflowY: {xs: 'visible', md: 'auto'},
    overflowX: 'hidden',
    width: '100%',
    minWidth: 0,
};

export const emptyStateSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 1,
    padding: theme.spacing(40 / 8, 16 / 8),
    color: theme.palette.neutral[500],
    textAlign: 'center',
};
